module.exports = __webpack_public_path__ + "static/media/discord.a1b36dda.svg";